import { toast } from 'react-toastify';

import { SnackbarOptions, ToastOptions, Id } from './types';

export const useNotification = () => {
  const enqueueSnackbar = (
    message: string,
    options: SnackbarOptions = {},
  ): Id => {
    const { variant = 'default', action, ...rest } = options;

    let toastFunction: (message: string, options?: ToastOptions) => Id;

    switch (variant) {
      case 'success':
        toastFunction = toast.success;
        break;
      case 'error':
        toastFunction = toast.error;
        break;
      case 'warning':
        toastFunction = toast.warning;
        break;
      case 'info':
        toastFunction = toast.info;
        break;
      default:
        toastFunction = toast;
    }

    const toastId = toastFunction(message, {
      ...rest,
    });

    return toastId;
  };

  /** Programmatically dismiss a specific toast by its ID. */
  const dismissSnackbar = (id: Id): void => {
    toast.dismiss(id);
  };

  return { enqueueSnackbar, dismissSnackbar };
};
